<template>
<kt-row v-if="status === 'setFormData'">
    <kt-col xs="12">
        <form @submit.prevent="edit" id="settings_form">
            <kt-form-group>
                <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                    <div class="custom-control custom-checkbox" id="reports_setting-div">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="reports_setting"
                                name="reports_setting"
                                v-model="gateway.show_psp_report_to_user"
                        >
                        <label class="custom-control-label" id="reports_setting_label" for="reports_setting">
                            {{ $t('label.showPSPReportToUser') }}
                        </label>
                    </div>
                </kt-row>

                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-form-select
                        v-if="gateway.can_be_sent_to_shaparak"
                        size="3"
                        id="status"
                        name="status"
                        v-model="gateway.status"
                >
                    <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses"
                            v-bind:value="status.value"
                            :selected="gateway.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
                <kt-form-select v-else size="3" id="status" name="status" v-model="gateway.status">
                    <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses_without_send_to_shaparak"
                            v-bind:value="status.value"
                            :selected="gateway.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>
            
            <kt-form-group> 
                <kt-form-label>
                    {{ $t('label.change_limitation') }}
                </kt-form-label>
                <kt-form-select size="3" id="limit" name="limit" v-model="gateway.has_limit">
                    <option
                        v-bind:key="index"
                        v-for="(limit, index) in limits"
                        v-bind:value="limit.value"
                        :selected="gateway.has_limit === limit.value"
                    >
                        {{ limit.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>
            <transition name="fade">
                <kt-form-group v-if="gateway.has_limit === '1' || gateway.has_limit === 1">
                    <kt-form-label>
                        {{ $t('label.limit_amount') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="limit_amount" name="limit_amount" v-model="gateway.limit_amount">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="psp_transactions_only" name="psp_transactions_only" v-model="gateway.psp_transactions_only">
                    <label class="custom-control-label" for="psp_transactions_only">{{ $t('label.psp_transactions_only') }}</label>
                </div>
            </kt-form-group>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="partial_settlement" name="partial_settlement" v-model="gateway.partial_settlement">
                    <label class="custom-control-label" for="partial_settlement">{{ $t('label.partial_settlement') }}</label>
                </div>
            </kt-form-group>

            <transition name="fade">
                <kt-form-group v-if="gateway.partial_settlement">
                    <kt-form-label>
                        {{ $t('label.settlement_percent') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control
                                type="number"
                                min="1"
                                max="99"
                                dir="ltr"
                                id="settlement_percent"
                                name="settlement_percent"
                                v-model="gateway.settlement_percent"
                        >
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('label.percent') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                            type="checkbox"
                            class="custom-control-input"
                            id="wage_to_sheba"
                            name="wage_to_sheba"
                            v-model="gateway.wage_to_sheba"
                            @change="initChangeSwitch()"
                    >
                    <label class="custom-control-label" for="wage_to_sheba">{{ $t('label.wage_to_sheba') }}</label>
                </div>
            </kt-form-group>

            <transition name="fade">
                <kt-form-group v-if="gateway.wage_to_sheba">
                    <kt-form-label>
                        {{ $t('label.sheba_number') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--right">
                        <kt-form-control
                                dir="ltr"
                                @focusin="initFocusInput()"
                                id="wage_sheba_number"
                                name="wage_sheba_number"
                                v-model="gateway.wage_sheba_number"
                        >
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--right">
                            <span>IR</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_wage_type') }}
                </kt-form-label>
                <kt-form-select size="3" id="wage_type" name="wage_type" v-model="gateway.wage_type">
                    <option
                            v-bind:key="index"
                            v-for="(wage_type, index) in wage_types"
                            v-bind:value="wage_type.value"
                            :selected="wage_type.value"
                    >
                        {{ wage_type.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>
            <transition name="fade">
                <kt-form-group v-if="gateway.wage_type === 'PERIODIC'">
                    <kt-form-label>
                        {{ $t('label.change_wage_period') }}
                    </kt-form-label>
                    <kt-form-select
                            size="4"
                            id="wage_periodic_type"
                            name="wage_periodic_type"
                            v-model="gateway.wage_periodic_type"
                    >
                        <option
                                v-bind:key="index"
                                v-for="(wage_periodic_type, index) in wage_periodic_types"
                                v-bind:value="wage_periodic_type.value"
                                :selected="wage_periodic_type.value"
                        >
                            {{ wage_periodic_type.name }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group>
                    <kt-form-label>
                        {{
                        (gateway.wage_type === 'PERCENT') ?
                        $t('label.wage_amount_percent') :
                        ((gateway.wage_type === 'FIXED') ?
                        $t('label.wage_amount_fixed') :
                        $t('label.wage_amount_periodic'))
                        }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_amount" name="wage_amount" v-model="gateway.wage_amount">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{
                                (gateway.wage_type === 'PERCENT') ?
                                $t('label.percent'):
                                $t('currency.rial')
                                }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group v-if="gateway.wage_type === 'PERCENT'">
                    <kt-form-label>
                        {{ $t('label.max_wage_amount') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage" v-model="gateway.wage_max_wage">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-action class="mt-4">
                <kt-row>
                    <kt-col xs="12" md="6">
                        <button class="btn btn-md btn-success btn-wide"  type="submit" id="change_status_btn">
                            {{ $t('btn.edit') }}
                        </button>
                    </kt-col>
                    <kt-col xs="12" md="6" v-if="gateway.psp === 'novin'">
                            <button
                                    class="btn btn-md btn-primary btn-wide"
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#user-access-modal"
                                    id="change_user_access_btn"
                                    style="float: left"
                            >
                                {{ $t('label.change_gateway_details') }}
                            </button>
                        <!-- Modal -->
                        <div id="user-access-modal" class="modal fade" role="dialog">
                            <div class="modal-dialog">
                                <!-- Modal content-->
                                <div class="modal-content" id="user-access-modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title">
                                            {{ $t('label.change_gateway_details') }}
                                        </h4>
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p>{{ $t('label.change_gateway_details') }}</p>
                                        <kt-form-section>
                                            <kt-row class="mb-3">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <div class="custom-control custom-checkbox" id="logo-div">
                                                        <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                id="change_logo"
                                                                name="change_logo"
                                                        >
                                                        <label class="custom-control-label" for="change_logo">
                                                            {{ $t('label.change_logo') }}
                                                        </label>
                                                    </div>
                                                </kt-col>
                                            </kt-row>
                                            <kt-row class="mb-3">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <div class="custom-control custom-checkbox" id="websiteAddress-div">
                                                        <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                id="change_websiteAddress"
                                                                name="change_websiteAddress"
                                                        >
                                                        <label class="custom-control-label" for="change_websiteAddress">
                                                            {{ $t('label.change_websiteAddress') }}
                                                        </label>
                                                    </div>
                                                </kt-col>
                                            </kt-row>
                                            <kt-row class="mb-3">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <div class="custom-control custom-checkbox" id="gatewayName-div">
                                                        <input
                                                                type="checkbox"
                                                                class="custom-control-input"
                                                                id="change_gatewayName"
                                                                name="change_gatewayName"
                                                        >
                                                        <label class="custom-control-label" for="change_gatewayName">
                                                            {{ $t('label.change_gatewayName') }}
                                                        </label>
                                                    </div>
                                                </kt-col>
                                            </kt-row>
                                        </kt-form-section>
                                        <kt-form-action class="mt-4">
                                            <kt-button
                                                    class="m-2 btn-wide"
                                                    size="md"
                                                    variant="primary"
                                                    type="button"
                                                    v-bind:wide="true"
                                                    id="change_logo_btn"
                                                    @click="changeLogo"
                                            >
                                                {{ $t('btn.submit') }}
                                            </kt-button>
                                        </kt-form-action>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </kt-col>
                </kt-row>

            </kt-form-action>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'
import { mapGetters } from 'vuex'
import { gatewayService } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import { KTUtil } from '@/plugins/core/util'
import Inputmask from "inputmask";

export default {
    computed: {
        ...mapGetters('gateway', {
            gateway: 'form_data',
            status: 'status'
        }),
    },
    data() {
        return {
            statuses: [
                {
                    name: gatewayStatusStr.ACTIVE,
                    value: gatewayStatus.ACTIVE
                },
                {
                    name: gatewayStatusStr.PENDING,
                    value: gatewayStatus.PENDING
                },
                {
                    name: gatewayStatusStr.SEND_TO_SHAPARAK,
                    value: gatewayStatus.SEND_TO_SHAPARAK
                },
                {
                    name: gatewayStatusStr.REJECTED,
                    value: gatewayStatus.REJECTED
                },
                {
                    name: gatewayStatusStr.BLOCKED,
                    value: gatewayStatus.BLOCKED
                },
                {
                    name: gatewayStatusStr.REJECTED_BY_SHAPARAK,
                    value: gatewayStatus.REJECTED_BY_SHAPARAK
                },
                {
                    name: gatewayStatusStr.ENAMAD_AUTHENTICATED,
                    value: gatewayStatus.ENAMAD_AUTHENTICATED
                },
            ],
            statuses_without_send_to_shaparak: [
                {
                    name: gatewayStatusStr.ACTIVE,
                    value: gatewayStatus.ACTIVE
                },
                {
                    name: gatewayStatusStr.PENDING,
                    value: gatewayStatus.PENDING
                },
                {
                    name: gatewayStatusStr.REJECTED,
                    value: gatewayStatus.REJECTED
                },
                {
                    name: gatewayStatusStr.BLOCKED,
                    value: gatewayStatus.BLOCKED
                },
                {
                    name: gatewayStatusStr.REJECTED_BY_SHAPARAK,
                    value: gatewayStatus.REJECTED_BY_SHAPARAK
                },
            ],
            limits: [
                {
                    name: this.$t('limit.limited'),
                    value: 1
                },
                {
                    name: this.$t('limit.unlimited'),
                    value: 0,
                }
            ],
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 'PERCENT'
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 'FIXED'
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 'PERIODIC',
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ]
        }
    },
    methods: {
        edit(e) {
            let btn = $('#change_status_btn')
            let form = $('#settings_form')

            form.validate({
                rules: {
                    settlement_percent: {
                        required: this.gateway.partial_settlement,
                        min: 1,
                        max: 99
                    },
                    wage_sheba_number: {
                        required: this.gateway.wage_to_sheba
                    },
                }
            })

            if(!form.valid()) {
                return;
            }

            KTApp.progress(btn)

            let is_failed = false
            gatewayService.changeStatus(this.gateway.id, this.gateway.status)
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })

            gatewayService.showPSPReportForCommonUser(this.gateway.id, this.gateway.show_psp_report_to_user)
                .catch(({response}) => {
                    is_failed = true
                })

            gatewayService.changeLimitation(this.gateway.id, {
                has_limit: this.gateway.has_limit,
                limit_amount: this.gateway.limit_amount
            })
                .catch(({response}) => {
                    is_failed = true
                })

            gatewayService.changeSettlementSettings(this.gateway.id, {
                psp_transactions_only: this.gateway.psp_transactions_only,
                partial_settlement: this.gateway.partial_settlement,
                settlement_percent: this.gateway.settlement_percent,
                wage_to_sheba: this.gateway.wage_to_sheba,
                wage_sheba_number: this.gateway.wage_sheba_number,
            })
                .catch(({response}) => {
                    is_failed = true
                })

            gatewayService.changeWage(this.gateway.id, {
                wage_type: this.gateway.wage_type,
                wage_periodic_type: this.gateway.wage_periodic_type,
                wage_amount: this.gateway.wage_amount,
                wage_max_wage: this.gateway.wage_max_wage,
            })
                .catch(({response}) => {
                    is_failed = true
                })
                .finally(
                    response => {
                        KTApp.unprogress(btn)
                    }
                )

            if (is_failed) {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            } else {
                this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
            }
        },
        changeLogo(){
            $('#user-access-modal').modal('toggle')
            let  form = $('#settings_form')
            let btn = $('#change_logo_btn')
            // KTApp.progress(btn)
            KTUtil.scrollTop()

            let params = {
                change_logo : $('#change_logo').is(":checked"),
                change_websiteAddress : $('#change_websiteAddress').is(":checked"),
                change_gatewayName :  $('#change_gatewayName').is(":checked"),
                gateway_id : this.$route.params.hashid,
            }

            gatewayService.changeGatewayDetails(params).then(response => {
                // KTApp.unprogress(btn)
                if (response.data.status == 'ok'){
                    this.showMsg(form, 'success', response.data.message)
                }
            }).catch(({response}) => {
                // KTApp.unprogress(btn)
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            })
        },
        initFocusInput(){
            if (this.gateway.wage_to_sheba) {
                document.getElementById('wage_sheba_number') && Inputmask('9999-9999-9999-9999-9999-9999').mask(document.getElementById('wage_sheba_number'))
            }
        }
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
#change_logo_btn {
    margin-right: 3%;
}
</style>
